const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M19 3.75a2.75 2.75 0 0 1 2.75 2.75v10A3.75 3.75 0 0 1 18 20.25H5a2.75 2.75 0 0 1-2.75-2.75v-11A2.75 2.75 0 0 1 5 3.75zM5 5.25c-.69 0-1.25.56-1.25 1.25v11c0 .69.56 1.25 1.25 1.25h1.75V5.25zm3.25 13.5H18a2.25 2.25 0 0 0 2.25-2.25v-10c0-.69-.56-1.25-1.25-1.25H8.25z"/></svg>';
export {
  a as w
};
